import { Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import { useWindowWidth } from 'shared-state/display-options/hooks';
import 'styles/helpers.css';
import { getPresenceTooltip } from 'kits/language/stringHelpers';
import FavoriteAreas from './FavoriteAreas/FavoriteAreas';

export interface IAreaSwitchLowerTopBarProps {
    selectedArea?: string;
    options: any;
    areaGroupOptions: any;
    color?: string;
    handleSearchPersonIconClick: (event: any) => void;
    handleAreaGroupClick: (e: any, areaGroup: any) => void;
    handleAreaClick: (e: any, areaId: string) => void;
}
const AreaSwitchLowerTopBarView: React.FC<IAreaSwitchLowerTopBarProps> = ({ options, areaGroupOptions, color, handleAreaGroupClick, handleAreaClick }) => {
    const { smallLaptop } = useWindowWidth();

    const tabsOrDropdownOptions = useMemo(() => {
        return [...options, ...areaGroupOptions].map((option: any) => ({
            key: option.key,
            title: option.title,
            usersAndVisitorsCount: option.usersAndVisitorsCount,
            groupLevel: option?.groupLevel,
            parentAreaId: option?.parentAreaId
        }));
    }, [options, areaGroupOptions]);

    return (
        <Stack horizontal style={{ height: '100%' }} grow>
            {tabsOrDropdownOptions.length > 0 && (
                <FavoriteAreas
                    useDropdown={smallLaptop}
                    items={tabsOrDropdownOptions}
                    handleAreaGroupClick={(e, item) => handleAreaGroupClick(e, item as any)}
                    handleAreaClick={(e, item) => handleAreaClick(e, item as any)}
                    color={color}
                    getPresenceTooltip={getPresenceTooltip}
                />
            )}
        </Stack>
    );
};

export default AreaSwitchLowerTopBarView;
